<template>
  <div>
    <div
      class="modal fade"
      :ref="`modal-maintenance-asset`"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{ $t(maintenanceModalTitle) }} {{ maintenanceData.code ? `#${maintenanceData.code}` : null }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="">{{
                        $t("propertyMaintenance.maintenanceTitle")
                      }}</label>
                      <input
                        class="form-control"
                        type="text"
                        v-model="maintenanceData.maintenanceTitle"
                        disabled
                      />
                    </div>
                    <hr style="margin: 10px 0" />
                  </div>
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-12" style="padding-bottom: 10px;">
                        <label for="">{{
                          $t("propertyMaintenance.assetList")
                        }}</label>
                        <button
                          v-if="
                            maintenanceData.status ===
                              maintenanceStatusEnum.MAINTENANCE_TRACKING ||
                              maintenanceData.status ===
                                maintenanceStatusEnum.MAINTENANCE_PLANNING ||
                              (addNewType ===
                                maintenanceStatusEnum.MAINTENANCE_IN_PROCESSING &&
                                maintenanceData.id === 0)
                          "
                          style="padding: 0 5px;"
                          type="button"
                          class="btn btn-sm btn-primary pull-right"
                          @click="onShowModalSelectAsset"
                        >
                          <i class="glyphicon glyphicon-plus"></i>
                          {{ $t("common.addnew") }}
                        </button>
                      </div>
                      <div class="asset-selected-table col-md-12">
                        <b-table
                          striped
                          hover
                          :sticky-header="`250px`"
                          no-border-collapse
                          :items="assetItems"
                          :fields="assetFields"
                        >
                          <template #head()="scope">
                            <div class="">{{ $t(scope.label) }}</div>
                          </template>
                          <template #cell(status)="row">
                            <select
                              v-model="row.item.activityPlanStatus"
                              class="form-control"
                              name=""
                              id=""
                              @change="
                                onShowUpdateAssetStatus(
                                  row.item,
                                  row.item.activityPlanStatus
                                )
                              "
                              :disabled="
                                row.item.activityPlanStatus !==
                                  assetActivityPlanEnum.IN_PROCESSING
                              "
                            >
                              <option
                                v-for="(item, index) in activityPlanStatusList"
                                :key="item + index"
                                :value="item.value"
                                >{{ $t(item.text) }}</option
                              >
                            </select>
                          </template>
                          <template #cell(actions)="row">
                            <button
                              v-if="
                                maintenanceData.status ===
                                  maintenanceStatusEnum.MAINTENANCE_TRACKING ||
                                  maintenanceData.status ===
                                    maintenanceStatusEnum.MAINTENANCE_PLANNING ||
                                  (addNewType ===
                                    maintenanceStatusEnum.MAINTENANCE_IN_PROCESSING &&
                                    maintenanceData.id === 0)
                              "
                              class="btn btn-danger btn-sm"
                              style="margin-left: 6px;"
                              @click="onDeleteAsset(row.item, row.index)"
                            >
                              <i class="glyphicon glyphicon-trash"></i>
                            </button>
                          </template>
                        </b-table>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-md-12"
                    v-if="
                      addNewType !== maintenanceStatusEnum.MAINTENANCE_TRACKING
                    "
                  >
                    <hr style="margin: 10px 0" />
                  </div>
                </div>
                <div
                  class="row"
                  v-if="
                    addNewType !== maintenanceStatusEnum.MAINTENANCE_TRACKING
                  "
                >
                  <div class="col-md-6" v-if="feedbackId === null">
                    <div class="form-group">
                      <label for="">{{
                        $t("propertyMaintenance.typeOfMaintenance")
                      }}</label>
                      <v-select
                        class="clear"
                        :options="maintenanceTypeList"
                        :getOptionLabel="option => option.default"
                        :reduce="data => data.id"
                        label="text"
                        :placeholder="
                          $t('propertyMaintenance.typeOfMaintenance')
                        "
                        :clearable="false"
                        v-model="maintenanceData.maintenanceTypeValue"
                        @option:selected="onChangeMaintenanceType"
                        disabled
                      >
                        <template v-slot:option="option">
                          {{ $t(option.default) }}
                        </template>
                      </v-select>
                    </div>
                  </div>
                  <div class="col-md-6" v-if="feedbackId === null">
                    <div class="form-group">
                      <label for="">{{
                        $t("propertyMaintenance.maintenanceFunction")
                      }}</label>
                      <v-select
                        class="clear"
                        :options="maintenanceFunctionList"
                        :getOptionLabel="option => option.default"
                        :reduce="data => data.id"
                        label="text"
                        :placeholder="
                          $t('propertyMaintenance.maintenanceFunction')
                        "
                        :clearable="false"
                        v-model="maintenanceData.maintenanceFunctionValue"
                        @option:selected="onChangeMaintenanceFunction"
                        :disabled="addNewType === null"
                      >
                        <template v-slot:option="option">
                          {{ $t(option.default) }}
                        </template>
                      </v-select>
                    </div>
                  </div>
                  <!-- <div class="col-md-6">
                    <div class="form-group">
                      <label for="">{{ $t("property.asset.status") }}</label>
                      <b-form-select
                        v-model="maintenanceData.status"
                        class="form-control"
                      >
                        <b-form-select-option
                          v-for="(item, index) in maintenanceStatusList"
                          :key="(item, index)"
                          :value="item.value"
                          >{{ $t(item.text) }}</b-form-select-option
                        >
                      </b-form-select>
                    </div>
                  </div> -->
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">{{
                        $t("propertyMaintenance.scheduledMaintenanceDate")
                      }}</label>
                      <date-picker
                        :config="options"
                        v-model="maintenanceData.scheduledMaintenanceDate"
                        placeholder="DD/MM/YYYY"
                        :disabled="addNewType === null"
                      ></date-picker>
                    </div>
                  </div>
                  <div
                    class="col-md-6"
                    v-if="
                      addNewType ===
                        maintenanceStatusEnum.MAINTENANCE_IN_PROCESSING ||
                        addNewType === null
                    "
                  >
                    <div class="form-group">
                      <label for="">{{
                        $t("propertyMaintenance.implementationDate")
                      }}</label>
                      <date-picker
                        :config="options"
                        v-model="maintenanceData.maintainanceDate"
                        placeholder="DD/MM/YYYY"
                        :disabled="addNewType === null"
                      ></date-picker>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="">{{
                        $t("propertyMaintenance.assignTo")
                      }}</label>
                      <div class="input-group" v-if="maintenanceData.id !== 0">
                        <v-select
                          class="clear"
                          :options="userList"
                          :getOptionLabel="option => option.text"
                          :reduce="data => data.value"
                          label="text"
                          :placeholder="$t('propertyMaintenance.assignTo')"
                          v-model="maintenanceData.contacterId"
                          :disabled="addNewType === null || maintenanceData.id !== 0"
                        >
                          <template v-slot:option="option">
                            {{ $t(option.text) }}
                          </template>
                        </v-select>
                        <span
                          :title="$t('propertyMaintenance.assignTo')"
                          class="input-group-addon btn"
                          @click="onShowUpdateMaintenanceAssignTo"
                        >
                          <i class="fa fa-edit"></i>
                        </span>
                      </div>
                      <v-select
                        v-else
                        class="clear"
                        :options="userList"
                        :getOptionLabel="option => option.text"
                        :reduce="data => data.value"
                        label="text"
                        :placeholder="$t('propertyMaintenance.assignTo')"
                        v-model="maintenanceData.contacterId"
                        :disabled="addNewType === null"
                      >
                        <template v-slot:option="option">
                          {{ $t(option.text) }}
                        </template>
                      </v-select>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <hr style="margin: 10px 0" />
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="">{{ $t("common.description") }}</label>
                      <button
                        v-if="addNewType !== null"
                        style="padding: 0 5px"
                        type="button"
                        class="btn btn-primary pull-right"
                        @click="onOpenInputSelectFile(imgMaintenanceList.length + 1)"
                      >
                        <i class="glyphicon glyphicon-plus"></i>
                        {{ $t("common.addNewImg") }}
                      </button>
                      <textarea
                        class="form-control"
                        name=""
                        id=""
                        cols="30"
                        rows="4"
                        v-model="maintenanceData.description"
                        :placeholder="$t('common.description')"
                        :disabled="addNewType === null"
                      ></textarea>
                    </div>
                  </div>
                  <div class="col-md-12" v-show="imgMaintenanceList.length > 0">
                    <div class="content-border-class attach-file-class">
                      <div
                        class="apartment-img-block"
                        v-for="(item, index) in imgMaintenanceList"
                        :key="item + index"
                      >
                        <img
                          id="apartment-img-id"
                          class="apartment-type-class img-responsive"
                          :src="item.url"
                          alt="apartment-img"
                          @click="onClickOpenFile(item.url)"
                        />
                        <div class="img-action" v-if="addNewType !== null">
                          <span
                            style="color: #006ad4"
                            class="action-button"
                            @click="onOpenInputSelectFile(index)"
                            ><small>{{ $t("common.update") }}</small></span
                          >
                          <span
                            style="color: #f2404d"
                            class="action-button"
                            @click="onclickRemoveImg(index)"
                            ><small>{{ $t("common.delete") }}</small></span
                          >
                        </div>
                      </div>
                    </div>
                    <div style="padding-top: 6px; text-align: center">
                      <input
                        class="img-upload-input"
                        :id="`upload-img-input-maintenance`"
                        type="file"
                        accept="image/*"
                        @change="handleClick"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer" style="text-align: center">
            <button
              style="background-color: #f29911;border-color: #f29911;color:#fff"
              type="button"
              class="btn btn-default pull-left"
              @click="onCloseModal"
            >
              {{ $t("common.back") }}
            </button>
            <button
              v-if="
                addNewType !== null &&
                  addNewType ===
                    maintenanceStatusEnum.MAINTENANCE_IN_PROCESSING &&
                  !isHideCompleteBtn
              "
              type="button"
              class="btn btn-success"
              @click="onClickCompleteMaintenance"
            >
              {{ $t("common.complete") }}
            </button>
            <button
              v-if="addNewType !== null"
              type="button"
              class="btn btn-primary pull-right"
              @click="onSave"
            >
              {{ $t("common.save") }}
            </button>
            <button
              v-if="maintenanceData.id !== 0"
              type="button"
              class="btn btn-primary pull-right"
              @click="onPrintMaintenance"
            >
              <i class="glyphicon glyphicon-print"></i>
              {{ $t("common.print") }}
            </button>
          </div>
        </div>
      </div>
      <lte-core-alert
        v-for="snackbar in GET_SNACK_BAR"
        :key="snackbar.id"
        :item="snackbar"
      ></lte-core-alert>
    </div>
    <!--  -->
    <select-multiplate-asset-modal
      ref="selectMultiplateAssetModal"
      :modalTitle="`propertyMaintenance.assetList`"
      :filterAssetActivityPlan="true"
      :activityPlanMaintenanceTypeId="maintenanceData.maintenanceTypeValue"
      :activityPlanStatus="assetActivityPlanEnum.CREATE"
      @emitAssetSelect="emitAssetSelectFunction"
    />
    <!--  -->
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
    <!--  -->
    <lte-modal
      v-show="isShowModalUpdateAssetSelectStatus"
      @onConfirm="onConfirmUpdateAssetSelectStatus"
      @close="closeModalUpdateAssetSelectStatus"
      v-for="obj in objModalUpdateAssetSelectStatus"
      :key="obj.id"
      :item="obj"
      isShowComment
    ></lte-modal>
    <!--  -->
    <lte-modal
      v-show="isShowModalCompleteMaintenance"
      @onConfirm="onConfirmCompleteMaintenance"
      @close="closeModalCompleteMaintenance"
      v-for="obj in objModalCompleteMaintenance"
      :key="obj.id"
      :item="obj"
    ></lte-modal>
    <!--  -->
    <div class="modal modal-default" ref="modal-maintenance-assignTo" 
      data-keyboard="false"
      data-backdrop="static">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              @click="onCloseMaintenanceAssignTo()"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{ $t("propertyMaintenance.assignTo") }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="">{{
                    $t("propertyMaintenance.assignTo")
                  }}</label>
                  <v-select
                    class="clear"
                    :options="userList"
                    :getOptionLabel="option => option.text"
                    :reduce="data => data.value"
                    label="text"
                    :placeholder="$t('propertyMaintenance.assignTo')"
                    v-model="contacterSelect"
                    :disabled="addNewType === null"
                  >
                    <template v-slot:option="option">
                      {{ $t(option.text) }}
                    </template>
                  </v-select>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary btn-sm pull-right"
              @click="onUpdateMaintenanceAssignTo"
            >
              {{ $t("common.confirm") }}
            </button>
            <button
              type="button"
              class="btn btn-warning btn-sm pull-left"
              @click="onCloseMaintenanceAssignTo()"
            >
              {{ $t("common.back") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--  -->
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import utils from '@/lib/utils';
import constantsData from "@/lib/constantsData";
import datePicker from "vue-bootstrap-datetimepicker";
import moment from "moment";
import Enum from "../../../enum/enum";
import DateUtils from "@/lib/dateUtils";
import axios from "axios";
//
import SelectMultiplateAssetModal from "./SelectMultiplateAssetModal";
import Loading from "vue-loading-overlay";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import LTEModal from "@/components/LTEModal.vue";

export default {
  components: {
    "date-picker": datePicker,
    SelectMultiplateAssetModal,
    loading: Loading,
    "lte-core-alert": LTECoreAlert,
    "lte-modal": LTEModal,
  },
  data: () => ({
    maintenanceModalTitle: "",
    options: {
      format: "DD/MM/YYYY",
      useCurrent: false
    },
    maintenanceData: {
      id: 0,
      code: null,
      typeOfMaintenance: 1,
      maintenanceTypeValue: null,
      maintenanceFunctionValue: null,
      status: 1,
      contacterId: null,
      maintainanceDate: null,
      scheduledMaintenanceDate: null,
      maintenanceTitle: null,
      description: null
    },
    assetList: [],
    maintenanceTypeList: [],
    maintenanceFunctionList: [],
    userList: [],
    maintenanceStatusList: constantsData.maintenanceStatusList,
    addNewType: null,
    maintenanceStatusEnum: Enum.MaintenanceStatusEnum,
    STATIC_FORMAT_DATE_TIME_ZONE_T: DateUtils.STATIC_FORMAT_DATE_TIME_ZONE_T,
    STATIC_FORMAT_DATE: DateUtils.STATIC_FORMAT_DATE,
    isHideCompleteBtn: false,
    feedbackId: null,
    assetItems: [],
    assetFromAddNewSelect: [],
    assetFields: [],
    assetFieldsAddNew: [
      {
        key: "nonumber",
        label: "common.nonumber"
      },
      {
        key: "assetCode",
        label: "common.code"
      },
      {
        key: "assetName",
        label: "property.asset.name"
      },
      // {
      //   key: "assetLocation",
      //   label: "property.asset.location"
      // },
      {
        key: "assetSeriCode",
        label: "property.asset.seriCode"
      },
      {
        key: "assetModel",
        label: "property.asset.model"
      },
      {
        key: "actions",
        label: "common.action"
      }
    ],
    assetFieldsDetail: [
      {
        key: "nonumber",
        label: "common.nonumber"
      },
      {
        key: "assetCode",
        label: "common.code"
      },
      {
        key: "assetName",
        label: "property.asset.name"
      },
      // {
      //   key: "assetLocation",
      //   label: "property.asset.location"
      // },
      // {
      //   key: "assetLocation",
      //   label: "property.asset.location"
      // },
      {
        key: "assetSeriCode",
        label: "property.asset.seriCode"
      },
      {
        key: "assetModel",
        label: "property.asset.model"
      },
      {
        key: "status",
        label: "property.asset.status"
      }
      // {
      //   key: "actions",
      //   label: "common.action"
      // }
    ],
    isLoading: false,
    imgMaintenanceList: [],
    imgMaintenanceUploadIndex: 0,
    imgUploadData: {
      url: null,
      size: null,
      file: null
    },
    media_server: {
      domain: "",
      token: ""
    },
    maintenanceTypeName: "",
    maintenanceFunctionName: "",
    assetActivityPlanEnum: Enum.AssetActivityPlanEnum,
    assetSelectData: null,
    assetSelectStatusValue: null,
    assetSelectComment: null,
    objModalUpdateAssetSelectStatus: [
      {
        title: "common.confirm",
        body: "propertyMaintenance.notiCancelMaintenance",
        buttonNo: "common.delete_modal.btnNo",
        buttonYes: "common.delete_modal.btnYes",
        styleType: "default"
      }
    ],
    isShowModalUpdateAssetSelectStatus: false,
    activityPlanStatusList: [
      {
        value: Enum.AssetActivityPlanEnum.IN_PROCESSING,
        text: "propertyMaintenance.statusList.processing"
      },
      {
        value: Enum.AssetActivityPlanEnum.COMPLETE,
        text: "propertyMaintenance.assetInProcessingMaintenanceStatus.processed"
      },
      {
        value: Enum.AssetActivityPlanEnum.CANCEL,
        text:
          "propertyMaintenance.assetInProcessingMaintenanceStatus.noProcessing"
      }
    ],
    // 
    activityPlanSelectList: [],
    isShowModalCompleteMaintenance: false,
    objModalCompleteMaintenance: [
      {
        title: "common.confirm",
        body: "propertyMaintenance.notiCompleteMaintenance",
        buttonNo: "common.delete_modal.btnNo",
        buttonYes: "common.delete_modal.btnYes",
        styleType: "default"
      }
    ],
    // 
    contacterSelect: null
  }),
  watch: {
    GET_ASSET_LIST_V2_NO_PAGE_DATA: function() {
      this.assetList = [];
      let data = this.GET_ASSET_LIST_V2_NO_PAGE_DATA;
      data.forEach(v => {
        let item = {
          id: v.id,
          code: v.code,
          name: v.name,
          location: v.location,
          maintenanceType: v.maintenance_type,
          lastMaintenanceDate: this.formatDateTime(v.last_maintenance_date, this.STATIC_FORMAT_DATE_TIME_ZONE_T, this.STATIC_FORMAT_DATE),
          nextMaintainanceDate: this.formatDateTime(v.next_maintainance_date, this.STATIC_FORMAT_DATE_TIME_ZONE_T, this.STATIC_FORMAT_DATE)
        };
        this.assetList.push(item);
      });
      // this.assetList = data;
    },
    GET_MAINTENANCE_TYPE_LIST_DATA: function() {
      let data = this.GET_MAINTENANCE_TYPE_LIST_DATA;
      this.maintenanceTypeList = data;
    },
    GET_USER_DATA: function() {
      this.userList = [];
      this.GET_USER_DATA.forEach(user => {
        let full_name = `${user.lastname} ${user.firstname}`;
        let item = {
          value: user.id,
          text: full_name
        };
        this.userList.push(item);
      });
    },
    GET_MAINTENANCE_DETAIL_DATA: function() {
      let data = this.GET_MAINTENANCE_DETAIL_DATA;
      let assetList = data.asset_list_data;
      this.assetItems = [];
      assetList.forEach((e, index) => {
        let item = {
          id: e.id,
          nonumber: index + 1,
          assetCode: e.code,
          assetName: e.name,
          assetLocation: e.location,
          assetModel: e.asset_model,
          assetSeriCode: e.seri_code,
          activityPlanStatus: e.activity_plan_status
        };
        this.assetItems.push(item);
      });
      this.maintenanceData.maintenanceTitle = data.title;
      this.maintenanceData.description = data.description;
      this.imgMaintenanceList = !utils.isNull(data.file_list) ? data.file_list : [];
    },
    GET_TOKEN_UPLOAD_DATA: function() {
      let data = this.GET_TOKEN_UPLOAD_DATA;
      this.media_server.domain = data.domain;
      this.media_server.token = data.token;
    }
  },
  computed: {
    ...mapGetters([
      "GET_ASSET_LIST_V2_NO_PAGE_DATA",
      "GET_MAINTENANCE_TYPE_LIST_DATA",
      "GET_USER_DATA",
      "GET_MAINTENANCE_DETAIL_DATA",
      "GET_SNACK_BAR",
      "GET_TOKEN_UPLOAD_DATA"
    ])
  },
  methods: {
    formatDateTime: function(value, fromFormat, toFormat) {
      if (!utils.isEmptyString(value)) {
        return DateUtils.formatDate(value, fromFormat, toFormat);
      }
      return null
    },
    onCloseModal: function() {
      $(this.$refs[`modal-maintenance-asset`]).modal("hide");
    },
    onShowModal: function() {
      $(this.$refs[`modal-maintenance-asset`]).modal("show");
    },
    getTitleModal: function(id, value) {
      if (id === 0) {
        if (value === this.maintenanceStatusEnum.MAINTENANCE_TRACKING) {
          this.maintenanceModalTitle =
            "propertyMaintenance.addNewMaintenanceTracking";
        } else if (value === this.maintenanceStatusEnum.MAINTENANCE_PLANNING) {
          this.maintenanceModalTitle =
            "propertyMaintenance.addNewMaintenancePlan";
        } else if (
          value === this.maintenanceStatusEnum.MAINTENANCE_IN_PROCESSING
        ) {
          this.maintenanceModalTitle =
            "propertyMaintenance.addNewInProcessingMaintenance";
        }
      } else {
        if (value === this.maintenanceStatusEnum.MAINTENANCE_TRACKING) {
          this.maintenanceModalTitle =
            "propertyMaintenance.maintenanceTrackingDetail";
        } else if (value === this.maintenanceStatusEnum.MAINTENANCE_PLANNING) {
          this.maintenanceModalTitle =
            "propertyMaintenance.maintenancePlanDetail";
        } else if (
          value === this.maintenanceStatusEnum.MAINTENANCE_IN_PROCESSING
        ) {
          this.maintenanceModalTitle =
            "propertyMaintenance.inProcessingMaintenanceDetail";
        }
      }
    },
    addNew: function(addNewType, feedbackId, isIncident, maintenanceType, activityPlanSelectList) {
      this.assetFields = this.assetFieldsAddNew;
      this.isHideCompleteBtn = true;
      this.addNewType = addNewType;
      this.assetItems = [];
      this.maintenanceData = {
        id: 0,
        code: null,
        typeOfMaintenance: 1,
        maintenanceTypeValue: 1,
        maintenanceFunctionValue: null,
        status: addNewType,
        contacterId: null,
        maintainanceDate: null,
        scheduledMaintenanceDate: null,
        maintenanceTitle: null,
        description: null
      };
      this.imgMaintenanceList = [];
      this.onShowModal();
      this.getTokenMedia();
      this.getUserList()
      if (feedbackId || isIncident) {
        this.feedbackId = feedbackId !== null ? feedbackId : null;
        this.maintenanceModalTitle = "feedback.incidentReport.title";
        this.maintenanceData.maintenanceTypeValue =
          Enum.MaintenanceTypeEnum.INCIDENT;
        let maintenanceFunctionIndex = this.maintenanceTypeList.findIndex(
          x => x.id === Enum.MaintenanceTypeEnum.INCIDENT
        );
        if (maintenanceFunctionIndex !== -1) {
          this.onChangeMaintenanceType(
            this.maintenanceTypeList[maintenanceFunctionIndex]
          );
          this.maintenanceTypeName = `Thực Hiện ${this.maintenanceTypeList[maintenanceFunctionIndex].default}`;
          this.maintenanceData.maintenanceTitle = this.maintenanceTypeName;
        }
      } else if (maintenanceType) {
        this.maintenanceData.maintenanceTypeValue = maintenanceType;
        let maintenanceFunctionIndex = this.maintenanceTypeList.findIndex(
          x => x.id === maintenanceType
        );
        if (maintenanceFunctionIndex !== -1) {
          this.onChangeMaintenanceType(
            this.maintenanceTypeList[maintenanceFunctionIndex]
          );
          this.maintenanceTypeName = `Thực Hiện ${this.maintenanceTypeList[maintenanceFunctionIndex].default}`;
          this.maintenanceData.maintenanceTitle = this.maintenanceTypeName;
        }
        this.feedbackId = null;
        this.getTitleModal(this.maintenanceData.id, addNewType);
      } else {
        this.onChangeMaintenanceType(this.maintenanceTypeList[0]);
        this.feedbackId = null;
        this.getTitleModal(this.maintenanceData.id, addNewType);
      }
      if (activityPlanSelectList !== undefined) {
        this.activityPlanSelectList = activityPlanSelectList
        this.getAssetList()
      } else {
        this.activityPlanSelectList = []
      }
    },
    showDetail: function(data, addNewType) {
      this.assetFields = this.assetFieldsDetail;
      this.isHideCompleteBtn = false;
      this.addNewType = addNewType;
      this.maintenanceData.id = data.id;
      this.maintenanceData.code = data.maintenanceCode
      this.maintenanceData.typeOfMaintenance = 1;
      this.maintenanceData.maintenanceTypeValue = data.maintenanceTypeValue;
      this.maintenanceData.maintenanceFunctionValue =
        data.maintenanceFunctionValue;
      this.maintenanceData.status = data.status;
      this.maintenanceData.contacterId = data.contacterId;
      this.maintenanceData.maintainanceDate = data.maintainanceStartDate;
      this.maintenanceData.scheduledMaintenanceDate =
        data.scheduledMaintenanceDate;
      let maintenanceFunctionIndex = this.maintenanceTypeList.findIndex(
        x => x.id === data.maintenanceTypeValue
      );
      if (maintenanceFunctionIndex !== -1) {
        this.onChangeMaintenanceType(
          this.maintenanceTypeList[maintenanceFunctionIndex]
        );
        this.maintenanceTypeName = `Thực Hiện ${this.maintenanceTypeList[maintenanceFunctionIndex].default}`;
      }
      this.maintenanceData.maintenanceTitle = data.maintenanceTitle;
      this.getTitleModal(this.maintenanceData.id, addNewType);
      this.getMaintenanceDetail(data.id);
      this.onShowModal();
      this.getUserList()
      this.getTokenMedia();
    },
    onSave: function() {
      // if (
      //   utils.isEmptyString(this.maintenanceData.maintenanceTitle) &&
      //   this.maintenanceData.status !== Enum.MaintenanceStatusEnum.MAINTENANCE_CANCELED
      // ) {
      //   this.ON_SHOW_TOAST({
      //     message: this.$t("propertyMaintenance.maintenanceTitle"),
      //     styleType: "danger"
      //   });
      // } else
      if (
        this.assetItems.length === 0 &&
        this.maintenanceData.status !==
          Enum.MaintenanceStatusEnum.MAINTENANCE_CANCELED
      ) {
        this.ON_SHOW_TOAST({
          message: this.$t("propertyMaintenance.assetList"),
          styleType: "danger"
        });
      } else if (
        utils.isEmptyString(this.maintenanceData.maintenanceTypeValue) &&
        this.addNewType !== this.maintenanceStatusEnum.MAINTENANCE_TRACKING
      ) {
        this.ON_SHOW_TOAST({
          message: this.$t("propertyMaintenance.typeOfMaintenance"),
          styleType: "danger"
        });
      } else if (utils.isEmptyString(this.maintenanceData.maintenanceFunctionValue) &&
        this.addNewType !== this.maintenanceStatusEnum.MAINTENANCE_TRACKING &&
        this.maintenanceData.maintenanceTypeValue !==Enum.MaintenanceTypeEnum.INCIDENT
      ) {
        this.ON_SHOW_TOAST({
          message: this.$t("propertyMaintenance.maintenanceFunction"),
          styleType: "danger"
        });
      } else {
        this.isLoading = true
        let data = {
          id: this.maintenanceData.id,
          maintenance_type:
            this.addNewType !== this.maintenanceStatusEnum.MAINTENANCE_TRACKING
              ? this.maintenanceData.maintenanceTypeValue
              : null,
          maintenance_function: this.maintenanceData.maintenanceFunctionValue,
          contacter_id: this.maintenanceData.contacterId,
          status: this.maintenanceData.status,
          maintainance_date: !utils.isEmptyString(this.maintenanceData.maintainanceDate)
            ? moment(this.maintenanceData.maintainanceDate, "DD/MM/YYYY").utc() : null,
          scheduledMaintenanceDate: !utils.isEmptyString(this.maintenanceData.scheduledMaintenanceDate)
            ? moment(this.maintenanceData.scheduledMaintenanceDate, "DD/MM/YYYY").utc() : null,
          assetList: this.assetItems,
          maintenanceTitle: this.maintenanceData.maintenanceTitle,
          description: this.maintenanceData.description,
          imgList: this.imgMaintenanceList,
          activityPlanSelectList: this.activityPlanSelectList,
          assetFromAddNewSelect: this.assetFromAddNewSelect
        };
        if (this.feedbackId !== null) {
          data["feedbackId"] = this.feedbackId;
        }
        if (this.maintenanceData.id === 0) {
          this.CREATE_MAINTENANCE(data)
            .then(
              function() {
                this.SUCCESS_TOAST();
                this.$emit("callbackMaintenanceList", true);
                this.onCloseModal();
                this.isLoading = false
              }.bind(this)
            )
            .catch(
              function(error) {
                this.ON_SHOW_TOAST({
                  message: error.response.data.message,
                  styleType: "danger"
                });
                this.isLoading = false
              }.bind(this)
            );
        } else {
          this.UPDATE_MAINTENANCE(data)
            .then(
              function() {
                this.SUCCESS_TOAST();
                this.$emit("callbackMaintenanceList", true);
                this.onCloseModal();
                this.closeModalCompleteMaintenance()
                this.isLoading = false
              }.bind(this)
            )
            .catch(
              function(error) {
                this.ON_SHOW_TOAST({
                  message: error.response.data.message,
                  styleType: "danger"
                });
                this.isLoading = false
              }.bind(this)
            );
        }
      }
    },
    onChangeMaintenanceType: function(data) {
      this.maintenanceFunctionList = data.maintenance_function;
    },
    maintenanceAssetAction: function(actionType, data) {
      this.isHideCompleteBtn = true;
      this.addNewType = actionType;
      //
      if (actionType === this.maintenanceStatusEnum.MAINTENANCE_PLANNING) {
        this.maintenanceModalTitle = this.$t(
          "propertyMaintenance.trackingTitle"
        );
      } else if (
        actionType === this.maintenanceStatusEnum.MAINTENANCE_IN_PROCESSING
      ) {
        this.maintenanceModalTitle = this.$t(
          "propertyMaintenance.maintenanceInProcessing"
        );
      }
      //
      this.maintenanceData = {
        id: data.id,
        typeOfMaintenance: 1,
        maintenanceTypeValue: data.maintenanceTypeValue,
        maintenanceFunctionValue: data.maintenanceFunctionValue,
        status: actionType,
        contacterId: data.contacterId,
        maintainanceDate: data.maintainanceStartDate,
        scheduledMaintenanceDate: data.scheduledMaintenanceDate
      };
      let maintenanceFunctionIndex = this.maintenanceTypeList.findIndex(
        x => x.id === data.maintenanceTypeValue
      );
      if (maintenanceFunctionIndex !== -1) {
        this.onChangeMaintenanceType(
          this.maintenanceTypeList[maintenanceFunctionIndex]
        );
      }
      this.getMaintenanceDetail(data.id);
      //
      this.onShowModal();
      this.getTokenMedia();
    },
    maintenanceCancelAction: function(actionType, data) {
      this.maintenanceData = {
        id: data.id,
        typeOfMaintenance: 1,
        maintenanceTypeValue: data.maintenanceTypeValue,
        maintenanceFunctionValue: data.maintenanceFunctionValue,
        status: actionType,
        contacterId: data.contacterId,
        maintainanceDate: data.maintainanceStartDate,
        scheduledMaintenanceDate: data.scheduledMaintenanceDate,
        maintenanceTitle: data.maintenanceTitle,
        description: data.maintenanceDescription
      };
      this.onSave();
    },
    onClickCompleteMaintenance: function() {
      let checkAssetStatus = this.assetItems.findIndex(x=>x.activityPlanStatus === Enum.AssetActivityPlanEnum.IN_PROCESSING)
      if (utils.isEmptyString(this.maintenanceData.maintainanceDate)) {
        this.ON_SHOW_TOAST({
          message: this.$t("propertyMaintenance.implementationDate"),
          styleType: "danger"
        });
      } else if (utils.isEmptyString(this.maintenanceData.contacterId)) {
        this.ON_SHOW_TOAST({
          message: this.$t("propertyMaintenance.assignTo"),
          styleType: "danger"
        });
      } else if (checkAssetStatus !== -1) {
        this.ON_SHOW_TOAST({
          message: this.$t("propertyMaintenance.mustUpdateAssetActivityPlanStatus"),
          styleType: "danger"
        });
      } else {
        this.isShowModalCompleteMaintenance = true
      }
    },
    onShowModalSelectAsset: function() {
      this.$refs.selectMultiplateAssetModal.onSelectAsset();
    },
    emitAssetSelectFunction: function(data) {
      let objKey = Object.keys(data);
      if (objKey.includes("assetList")) {
        let assetSelectList = data.assetList
        assetSelectList.forEach((e, index) => {
          let asset_exist = this.assetItems.findIndex(x => x.id === e.id);
          let item = {
            id: e.id,
            nonumber: index + 1,
            assetCode: e.assetCode,
            assetName: e.assetName,
            assetLocation: e.assetLocation,
            assetModel: e.assetModel,
            assetSeriCode: e.assetSeriCode
          };
          if (asset_exist === -1) {
            this.assetItems.push(item);
            this.assetFromAddNewSelect.push(e.id)
          }
        });
        this.$refs.selectMultiplateAssetModal.onCloseModal();
      }
    },
    getMaintenanceDetail: function(maintenanceId) {
      let filter = {
        id: maintenanceId
      };
      this.isLoading = true;
      this.GET_MAINTENANCE_DETAIL(filter)
        .then(
          function() {
            this.isLoading = false;
          }.bind(this)
        )
        .catch(
          function(error) {
            this.isLoading = false;
          }.bind(this)
        );
    },
    onDeleteAsset: function(data, index) {
      this.assetItems.splice(index, 1);
      let assetFromAddNewIndex = this.assetFromAddNewSelect.findIndex(x=>x === data.id)
      if (assetFromAddNewIndex !== -1) {
        this.assetFromAddNewSelect.splice(assetFromAddNewIndex, 1);
      }
    },
    //
    onOpenInputSelectFile: function(index) {
      this.imgMaintenanceUploadIndex = index;
      $(`#upload-img-input-maintenance`).val("");
      $(`#upload-img-input-maintenance`).click();
    },
    handleClick: async function(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.getResultFile(files[0]);
      this.imgUploadData.size = files[0].size;
      this.uploadImgMaintenanceFunction();
      this.addAndUpdateImgList();
    },
    addAndUpdateImgList: function() {
      if (this.imgMaintenanceUploadIndex > this.imgMaintenanceList.length || this.imgMaintenanceList.length === 0) {
        let item = {
          url: this.imgUploadData.url
        };
        this.imgMaintenanceList.push(item);
      } else {
        let imgListElement = this.imgMaintenanceList[this.imgMaintenanceUploadIndex];
        imgListElement.url = this.imgUploadData.url;
      }
    },
    onclickRemoveImg: function(index) {
      this.imgMaintenanceList.splice(index, 1);
    },
    getResultFile: function(file) {
      let vm = this;
      vm.imgUploadData.file = file;
    },
    uploadImgMaintenanceFunction: async function() {
      if (this.imgUploadData.size > 10000000) {
        this.ON_SHOW_TOAST({
          message: this.$t("common.cannotExceed10MB"),
          styleType: "danger"
        });
      } else {
        let formData = new FormData();
        formData.append("file", this.imgUploadData.file);
        formData.append("directory", "maintenance");
        formData.append("forceOverride", true);
        await axios({
          method: "POST",
          timeout: 6000,
          url: this.media_server.domain + "/api/v1/upload/",
          data: formData,
          headers: { Authorization: `JWT ${this.media_server.token}` }
        })
          .then(
            function(res) {
              let imgUrl = res.data.domain + res.data.url;
              // let imgUrl = res.domain + res.url;
              this.imgUploadData.url = imgUrl;
            }.bind(this)
          )
          .catch(
            function(error) {
              this.ON_SHOW_TOAST({
                message: error.response.data.message,
                styleType: "danger"
              });
            }.bind(this)
          );
      }
    },
    getTokenMedia: function() {
      this.GET_TOKEN_UPLOAD();
    },
    onClickOpenFile: function(url) {
      window.open(url);
    },
    onChangeMaintenanceFunction: function(data) {
      this.maintenanceFunctionName = data.default;
      this.maintenanceData.maintenanceTitle = `${this.maintenanceTypeName} ${this.maintenanceFunctionName}`;
    },
    onShowUpdateAssetStatus: function(data, statusValue) {
      if (statusValue == this.assetActivityPlanEnum.COMPLETE) {
        this.objModalUpdateAssetSelectStatus[0].body =
          "propertyMaintenance.activityPlanStatusProcessedTitle";
      } else {
        this.objModalUpdateAssetSelectStatus[0].body =
          "propertyMaintenance.activityPlanStatusNoProcessedTitle";
      }
      this.isShowModalUpdateAssetSelectStatus = true;
      this.assetSelectData = data;
      this.assetSelectStatusValue = statusValue;
      this.assetSelectComment = null
    },
    closeModalUpdateAssetSelectStatus: function() {
      this.isShowModalUpdateAssetSelectStatus = false;
      this.onChangeAssetObjStatus(
        this.assetSelectData.id,
        this.assetActivityPlanEnum.IN_PROCESSING
      );
    },
    onChangeAssetObjStatus: function(assetId, statusValue) {
      let index = this.assetItems.findIndex(x => x.id === assetId);
      if (index !== -1) {
        this.assetItems[index].activityPlanStatus = statusValue;
      }
    },
    onConfirmUpdateAssetSelectStatus: function(dataEmit) {
      let objKeys = Object.keys(dataEmit)
      if (objKeys.includes('commentData')) {
        this.assetSelectComment = dataEmit.commentData
      }
      let data = {
        assetId: this.assetSelectData && this.assetSelectData.id,
        maintenanceId: this.maintenanceData.id,
        statusValue: this.assetSelectStatusValue,
        notes: this.assetSelectComment
      };
      this.UPDATE_STATUS_ACTIVITY_PLAN(data)
        .then(
          function() {
            this.isLoading = false;
            this.isShowModalUpdateAssetSelectStatus = false;
          }.bind(this)
        )
        .catch(
          function(error) {
            this.isLoading = false;
          }.bind(this)
        );
    },
    // 
    getAssetList: function() {
      this.isLoading = false
      let filter = {
        params: {
          activityPlanSelectList: this.activityPlanSelectList,
          activityPlanMaintenanceTypeId: this.maintenanceData.maintenanceTypeValue
        }
      };
      this.GET_ASSET_LIST_V2(filter)
        .then(
          function(res) {
            let assetList = res.data
            assetList.forEach((e, index)=>{
              let item = {
                id: e.id,
                nonumber: index + 1,
                assetCode: e.code,
                assetName: e.name,
                assetLocation: e.location,
                assetModel: e.asset_model,
                assetSeriCode: e.seri_code,
              };
              this.assetItems.push(item)
            })
            this.isLoading = false;
          }.bind(this)
        )
        .catch(
          function(error) {
            this.isLoading = false;
          }.bind(this)
        );
    },
    closeModalCompleteMaintenance: function() {
      this.isShowModalCompleteMaintenance = false
    },
    onConfirmCompleteMaintenance: function() {
      this.maintenanceData.status = this.maintenanceStatusEnum.MAINTENANCE_FINISHED;
      this.onSave();
    },
    getUserList: function() {
      this.GET_USER_LIST();
    },
    onShowUpdateMaintenanceAssignTo: function() {
      this.contacterSelect = this.maintenanceData.contacterId
      this.onShowMaintenanceAssignTo()
    },
    onUpdateMaintenanceAssignTo: function() {
      if (utils.isEmptyString(this.contacterSelect)) {
        this.ON_SHOW_TOAST({
          message: this.$t("propertyMaintenance.assetList"),
          styleType: "danger"
        });
      } else {
        this.isLoading = true;
        let data = {
          id: this.maintenanceData.id,
          contacterId: this.contacterSelect
        }
        this.UPDATE_MAINTENANCE_ASSIGN_TO(data)
          .then(
            function(res) {
              this.maintenanceData.contacterId = res.contacter_id
              this.isLoading = false;
              this.onCloseMaintenanceAssignTo()
            }.bind(this)
          )
          .catch(
            function(error) {
              this.isLoading = false;
            }.bind(this)
          );
      }
    },
    onCloseMaintenanceAssignTo: function() {
      $(this.$refs[`modal-maintenance-assignTo`]).modal("hide");
    },
    onShowMaintenanceAssignTo: function() {
      $(this.$refs[`modal-maintenance-assignTo`]).modal("show");
    },
    onPrintMaintenance: function() {
      let routeData = this.$router.resolve({
        name: "PrintMaintenance",
        params: {
          id: this.maintenanceData.id
        }
      })
      window.open(routeData.href, "_blank");
    },
    ...mapActions([
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST",
      "CREATE_MAINTENANCE",
      "UPDATE_MAINTENANCE",
      "GET_MAINTENANCE_DETAIL",
      "GET_TOKEN_UPLOAD",
      "UPDATE_STATUS_ACTIVITY_PLAN",
      "GET_ASSET_LIST_V2",
      "GET_USER_LIST",
      "UPDATE_MAINTENANCE_ASSIGN_TO"
    ])
  }
};
</script>
<style lang="scss" scoped>
.disable-input-background {
  background: #e4e7e8;
}

.asset-selected-table /deep/.b-table-sticky-header table thead tr th {
  background: #dddddd;
  border: 1px solid white;
}
.asset-selected-table /deep/.b-table-sticky-header table tbody tr td {
  border: 1px solid #e4e7e8;
}
.asset-selected-table /deep/.b-table-sticky-header table {
  border-collapse: separate;
  border-spacing: 0;
}
.asset-selected-table /deep/.b-table-sticky-header td:nth-child(1) {
  width: 10%;
  white-space: nowrap;
}
// .asset-selected-table /deep/.b-table-sticky-header td:nth-child(5) {
//   width: 10%;
//   white-space: nowrap;
// }
//
.img-upload-input {
  display: none;
  z-index: -9999;
}
.content-border-class {
  border: 1px solid #cccccc;
}
.attach-file-class {
  max-height: 150px;
  overflow: auto;
  padding: 10px;
}
.apartment-img-block {
  display: inline-block;
  margin-bottom: 15px;
}
.apartment-type-class {
  margin: auto;
  /* width: 100%; */
  width: 100px;
  height: 100px;
  object-fit: contain;
  padding: 5px;
  margin: 5px;
  border: 1px solid #cccccc;
  border-radius: 3%;
}
.apartment-type-class:hover {
  cursor: pointer;
}
.img-action {
  justify-content: space-between;
  display: flex;
  margin: 0 5px;
  padding: 0 5px;
}

.action-button:hover {
  text-decoration: underline;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/Property/MaintenanceModal.vue